import React, { useCallback, useState } from 'react';
import { makeCSS } from '../../utils/makeCSS';
import { TextareaAutosize, TextareaAutosizeProps } from '@material-ui/core';
import Button from './Button/Button';

const useStyles = makeCSS(({ theme }) => ({
  root: {
    background: theme.color.background.neutral,
    width: '100%',
    marginTop: 16,
    borderRadius: 6,
    '& > div': {
      borderRadius: 6
    },
    '& > textarea': {
      borderRadius: 6
    }
  },
  textarea: {
    border: 'none',
    background: theme.color.background.neutral,
    color: 'white',
    fontSize: 16,
    outline: 'none',
    resize: 'none',
    width: 'calc(100% - 16px)',
    padding: 8,
    margin: 0,
    '&:focus': {
      outline: 'none'
    }
  },
  textareaButtons: {
    background: theme.color.background.neutral
  },
  replyButtonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '8px',
    gap: 8
  }
}));

export interface TextAreaProps extends TextareaAutosizeProps {
  onSave: (msg: string) => void;
  setEditing: (editing: boolean) => void;
}

export const TextArea = (props: TextAreaProps) => {
  const { defaultValue, onSave, setEditing, ...restProps } = props;

  const [message, setMessage] = useState<string>();

  const onChangeMessage = useCallback(
    (e) => {
      setMessage(e.target.value);
    },
    [setMessage]
  );

  const onFocusTextArea = useCallback((e) => {
    // to place cursor at the end of text
    const val = e.target.value;
    e.target.value = '';
    e.target.value = val;
  }, []);
  const onSaveMessage = useCallback(() => {
    setEditing(false);
    if (message === defaultValue) return;
    onSave(message);
    setMessage(message);
  }, [message, onSave, setEditing, setMessage]);

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <TextareaAutosize
        {...restProps}
        style={{
          background: 'rgba(0,0,0,0,48)',
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '0.02em',
          fontFamily: 'Inter,sans-serif'
        }}
        autoFocus={true}
        defaultValue={defaultValue}
        className={classes.textarea}
        onChange={onChangeMessage}
        onFocus={onFocusTextArea}
        value={message}
      />
      <div className={`${classes.replyButtonGroup} ${classes.textareaButtons}`}>
        <Button
          background="secondary"
          buttonStyle="ghost"
          onClick={() => setEditing(false)}
          label={'Cancel'}
        />
        <Button
          background="secondary"
          buttonStyle="solid"
          onClick={onSaveMessage}
          disabled={!message}
          label={message === defaultValue ? 'Done' : 'Save'}
        />
      </div>
    </div>
  );
};
